import { useCallback } from 'react';
import { useColumns as useSharedColumns } from '@/components/ActivityLog/constants';

// Manifest activity log = the shared columns plus View/Resolve on EXCEPTION rows.
export const useColumns = ({ exceptionIndex, onExceptionAction, editable }) => {
    const getRowActions = useCallback(
        (log) => {
            if (log.entity_type !== 'EXCEPTION' || !log.entity_id) return [];
            const found = exceptionIndex[log.entity_id];
            if (!found) return [];
            // Open exceptions are resolvable by editors; everything else is view-only.
            const readOnly = found.exception?.status === 'RESOLVED' || !editable;
            return [{ label: readOnly ? 'View' : 'Resolve', onClick: () => onExceptionAction(found, readOnly) }];
        },
        [exceptionIndex, onExceptionAction, editable]
    );

    return useSharedColumns(false, getRowActions);
};
